module.exports = __webpack_public_path__ + "img/Y_TE.a0f2aa3d.svg";